import { createContext, useState, useEffect } from 'react';
import { IHContenidoSeguroDefault } from "./Data";
const param: IProviderIHContenidoSeguroCR = {} as IProviderIHContenidoSeguroCR;

const DataContext = createContext(param);

const DataProvier = ({ children }: any) => {
    const [IHContenidoSeguroCR, SetIHContenidoSeguroCR] = useState({ ...IHContenidoSeguroDefault });

    const ChangeHandler = (event: any) => SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, [event.target.name]: event.target.value });

    const ChangeHandler2 = (property: string, value: any) => SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, [property]: value });
    
    return (
        <DataContext.Provider value={{ IHContenidoSeguroCR, SetIHContenidoSeguroCR, ChangeHandler, ChangeHandler2 }}>
            {children}
        </DataContext.Provider>
    );
}



export { DataContext, DataProvier }